module.exports = __webpack_public_path__ + "static/logo-Outilslibres-168e91d31b2793ae31b5578dbf360e9c.svg";